import { render } from "./DesignerContent.vue?vue&type=template&id=159a6be7&scoped=true"
import script from "./DesignerContent.vue?vue&type=script&lang=js"
export * from "./DesignerContent.vue?vue&type=script&lang=js"

import "./DesignerContent.vue?vue&type=style&index=0&id=159a6be7&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159a6be7"]])

export default __exports__